import { render, staticRenderFns } from "./UnauthorizedLinks.vue?vue&type=template&id=1b285402&"
import script from "./UnauthorizedLinks.vue?vue&type=script&lang=ts&"
export * from "./UnauthorizedLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports